import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import reportWebVitals from './reportWebVitals';
import './setup/i18n/i18n';
import { AuthProvider } from "./setup/auth/authService";
import { ToastProvider } from './app/modules/layout/components/ToastContext';
import AppRoutes from './app/routing/AppRoutes';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'bootstrap-icons/font/bootstrap-icons.css';


const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  // <React.StrictMode>
      <ToastProvider>
        <AuthProvider>  
          <AppRoutes />
        </AuthProvider>
      </ToastProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();